import { NgModule } from "@angular/core";
import { SharedModule } from "../shared/shared.module";
import { RouterModule } from "@angular/router";
import { AuthGuard } from "../auth-guard.service";
import { AccountGuard } from "../account-guard.service";
import { InvoicingComponent } from "./invoicing.component";
import { InvoicingDetailComponent } from "./invoicingdetail.component";
import { InvoicingService } from "./invoicing.service";
import { InvoicingDetailStatementsComponent } from "./invoicingdetail.statements.component";
import { InvoicingDetailPaymentsComponent } from "./invoicingdetail.payments.component";
import { Invoicing2DetailPaymentsComponent } from "./invoicingdetails2.payments.component";
import { InvoicingDetailInvoicesComponent } from "./invoicingdetail.invoices.component";
import { InvoicingDetailEbillingComponent } from "./invoicingdetail.ebilling.component";
import { InvoicingDetailCertificatesComponent } from "./invoicingdetail.certificates.component";
import { InvoicingDetailNavigationComponent } from "./invoicingdetail.navigation.component";
import { HistoricalInvoicingComponent } from "./invoicingdetail.historicalinvoice.component";


@NgModule({
    imports: [
        SharedModule,
        RouterModule.forChild([
            { path: 'invoicing', component: InvoicingComponent, canActivate: [AuthGuard, AccountGuard] },
            { path: 'invoicingdetail/invoices', component: InvoicingDetailInvoicesComponent, canActivate: [AuthGuard, AccountGuard] },
            { path: 'invoicingdetail/statements', component: InvoicingDetailStatementsComponent, canActivate: [AuthGuard, AccountGuard] },
            { path: 'invoicingdetail/certificates', component: InvoicingDetailCertificatesComponent, canActivate: [AuthGuard, AccountGuard] },
            //{ path: 'invoicingdetail/payments', component: InvoicingDetailPaymentsComponent, canActivate: [AuthGuard, AccountGuard] },
            { path: 'invoicingdetail/payments', component: Invoicing2DetailPaymentsComponent, canActivate: [AuthGuard, AccountGuard] },
            { path: 'invoicingdetail/ebilling', component: InvoicingDetailEbillingComponent, canActivate: [AuthGuard, AccountGuard] },
            { path: 'invoicingdetail/historical-invoices', component: HistoricalInvoicingComponent, canActivate: [AuthGuard, AccountGuard] }
        ])
    ],
    exports: [

    ],
    declarations: [
        InvoicingComponent,
        InvoicingDetailComponent,
        InvoicingDetailStatementsComponent,
        InvoicingDetailPaymentsComponent,
        Invoicing2DetailPaymentsComponent,
        InvoicingDetailInvoicesComponent,
        InvoicingDetailEbillingComponent,
        InvoicingDetailCertificatesComponent,
        InvoicingDetailNavigationComponent,
        HistoricalInvoicingComponent
    ],
    providers: [
        InvoicingService
    ]
})
export class InvoicingModule {

}



// WEBPACK FOOTER //
// ./src/app/invoicing/invoicing.module.ts